import Axios from 'axios';

const apiCep = {
  async searchCep(cep) {
    return Axios.get(`https://viacep.com.br/ws/${cep}/json`);
  }
}

export default apiCep;